import { Auth0Provider } from '@auth0/auth0-react';
import React, { ReactNode, Suspense, lazy, useMemo } from 'react';
import { useFeatureFlagEnabled } from 'posthog-js/react';
import constVars from '~/constants/constVars';
import auth0Config from '~/helpers/auth0Config';
import { getAuth0Audience, getCookieValue } from '~/helpers/utils';
import { Auth0AuthProvider } from './Auth0AuthProvider';

const CognitoAuthProvider = lazy(() =>
  import('./CognitoAuthProvider').then((m) => ({
    default: m.CognitoAuthProvider,
  }))
);

export { CognitoAuthEvent, useAuth } from './AuthContext';

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const isCognitoEnabled = useFeatureFlagEnabled('cognito-authentication');

  const auth0Audience = getAuth0Audience();

  const hasIsAuthenticatedCookie = useMemo(() => {
    const auth0IsAuthenticatedCookie = getCookieValue(
      `auth0.${import.meta.env.VITE_AUTH0_CLIENT_ID}.is.authenticated`
    );

    return auth0IsAuthenticatedCookie === 'true';
  }, []);

  if (
    isCognitoEnabled &&
    auth0Audience !== constVars.AUTH_INTERNAL_PROD.AUDIENCE
  ) {
    return (
      <Suspense>
        <CognitoAuthProvider>{children}</CognitoAuthProvider>
      </Suspense>
    );
  }

  return (
    <Auth0Provider {...auth0Config}>
      <Auth0AuthProvider hasIsAuthenticatedCookie={hasIsAuthenticatedCookie}>
        {children}
      </Auth0AuthProvider>
    </Auth0Provider>
  );
};

export default AuthProvider;
